import React, { Component } from 'react';
import firebase from 'firebase';
import { Pulse } from 'react-preloading-component';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import ReactExport from "react-data-export";
import store from '../../store';
import { getAuth } from '../config/Paths';
import moment from 'moment';
import Calendario from '../../img/Calendario.svg';
import Kilometraje from '../../img/Kilometraje.svg';
import Pasajeros from '../../img/Pasajeros.svg';
import Reloj from '../../img/Reloj.svg';
import Ubicacion from '../../img/Ubicacion.svg';
import Flecha from '../../img/Flecha.png';

class BitacoraEmpleados extends Component {
	constructor(props) {
		super(props);
		this.state = {
			clienteR: [],
			centroR: [],
			ViajesR: [],
			empleadosR: [],
			vehiculosR: [],
			empresaR: [],
			tarifas: [],
			programaciones: [],
			DetalleViaje: [],
			empreUID: 'GudI9QD16ceP2Z2df28KVMeNI7h2', // Valor por defecto
			isLoading: true,
			fecha_desde: '',
			fecha_hasta: '',
			isPulse: false,
			showDatePickers: false,
			visiblePersonas: {},
			empresas: [] // Añadido para almacenar las empresas
		};
		this.handleChangeDatePicker1 = this.handleChangeDatePicker1.bind(this);
		this.handleChangeDatePicker2 = this.handleChangeDatePicker2.bind(this);
	}

	componentDidMount() {
		const curr = new Date();
		const date = curr.toLocaleDateString('en-CA'); // Formato 'YYYY-MM-DD'
		this.setState({ fecha_desde: date, fecha_hasta: date }, this.getData); // Llama a getData después de establecer las fechas
		this.getEmpresas();
	}

	componentDidUpdate(prevProps, prevState) {
		// Verifica si las fechas o empreUID han cambiado para volver a cargar los datos
		if (
			(prevState.fecha_desde !== this.state.fecha_desde && this.state.fecha_desde) ||
			(prevState.fecha_hasta !== this.state.fecha_hasta && this.state.fecha_hasta) ||
			prevState.empreUID !== this.state.empreUID
		) {
			this.setState({ isPulse: true }, this.getData);
		}
	}

	getEmpresas() {
		firebase.database().ref('Empresa').on('value', data => {
			let empresas = [];
			data.forEach(element => {
				let k = element.key;
				let valores = element.val();
				let name = valores.codigo_empresa;
				empresas.push({
					key: k,
					nombre: name
				});
			});
			this.setState({ empresas });
		});
	}

	getData = () => {
		const currentUser = firebase.auth().currentUser;
		if (!currentUser) {
			console.error('No hay usuario logeado.');
			return;
		}

		let { empreUID, fecha_desde, fecha_hasta } = this.state;

		if (!fecha_desde || !fecha_hasta) {
			console.error('Las fechas no están definidas.');
			return;
		}

		let fecha1 = new Date(fecha_desde);
		fecha1.setDate(fecha1.getDate() + 1);
		fecha1.setHours(0, 0, 0, 0);

		let fecha2 = new Date(fecha_hasta);
		fecha2.setDate(fecha2.getDate() + 1);
		fecha2.setHours(23, 59, 59, 999);

		let fechasEnMilisegundos = [];
		for (let d = fecha1; d <= fecha2; d.setDate(d.getDate() + 1)) {
			fechasEnMilisegundos.push(new Date(d).getTime());
		}

		let fechasEnFormatoRequerido = fechasEnMilisegundos.map(ms => {
			let fecha = new Date(ms);
			return fecha.toString();
		});

		this.setState({ isLoading: true });

		let promises = [];

		// Filtrar AsignacionViajes por fecha y conductor (usuario logeado)
		promises.push(
			firebase.database().ref('AsignacionViajes')
				.orderByChild('conduc')
				.equalTo(currentUser.uid)
				.once('value')
				.then(snapV => {
					let datosV = [];
					snapV.forEach(elementCli => {
						let objeC = elementCli.val();
						if (objeC.fecha !== undefined && fechasEnFormatoRequerido.includes(objeC.fecha)) {
							objeC.key = elementCli.key;
							datosV.push(objeC);
						}
					});
					datosV.sort((a, b) => new Date(a.fecha) - new Date(b.fecha)); // Ordenar por fecha
					this.setState({ ViajesR: datosV });
				})
		);

		// Filtrar Empleados por el usuario logeado
		promises.push(
			firebase.database().ref('Empleados')
				.orderByKey()
				.equalTo(currentUser.uid)
				.once('value')
				.then(snapE => {
					let datosE = [];
					snapE.forEach(elementCli => {
						let objeC = elementCli.val();
						objeC.key = elementCli.key;
						datosE.push(objeC);
					});
					this.setState({ empleadosR: datosE });
				})
		);

		promises.push(
			firebase.database().ref('Vehiculos').once('value').then(snapVe => {
				let datosVe = [];
				snapVe.forEach(elementCli => {
					let objeC = elementCli.val();
					objeC.key = elementCli.key;
					datosVe.push(objeC);
				});
				this.setState({ vehiculosR: datosVe });
			})
		);

		promises.push(
			firebase.database().ref('Clientes')
				.orderByChild('socio')
				.equalTo(empreUID)
				.once('value')
				.then(snapC => {
					let datosC = [];
					snapC.forEach(elementCli => {
						let objeC = elementCli.val();
						objeC.key = elementCli.key;
						datosC.push(objeC);
					});
					this.setState({ clienteR: datosC });
				})
		);

		promises.push(
			firebase.database().ref('CentroCosto')
				.orderByChild('empresa')
				.equalTo(empreUID)
				.once('value')
				.then(snapCo => {
					let datosCo = [];
					snapCo.forEach(elementCli => {
						let objeC = elementCli.val();
						objeC.key = elementCli.key;
						datosCo.push(objeC);
					});
					this.setState({ centroR: datosCo });
				})
		);

		promises.push(
			firebase.database().ref('Empresa/' + empreUID).once('value').then(snapEmp => {
				let empresa = snapEmp.val();
				this.setState({ empresaR: empresa });
			})
		);

		promises.push(
			firebase.database().ref('TarifasAvianca').once('value').then(snapTarifas => {
				let tarifas = [];
				snapTarifas.forEach(elementTar => {
					let objeT = elementTar.val();
					objeT.key = elementTar.key;
					tarifas.push(objeT);
				});
				this.setState({ tarifas });
			})
		);

		promises.push(
			firebase.database().ref('Programacion').once('value').then(snapP => {
				let programaciones = [];
				snapP.forEach(elementPro => {
					let progra = elementPro.val();
					progra.key = elementPro.key;
					programaciones.push(progra);
				});
				this.setState({ programaciones });
			})
		);

		promises.push(
			firebase.database().ref('DetalleViaje').once('value').then(snapDe => {
				let DetalleViaje = [];
				snapDe.forEach(elementDeta => {
					let progra = elementDeta.val();
					progra.key = elementDeta.key;
					DetalleViaje.push(progra);
				});
				this.setState({ DetalleViaje });
			})
		);

		Promise.all(promises).then(() => {
			let { clienteR, centroR } = this.state;

			if (clienteR.length === 0 && centroR.length === 0) {
				this.setState({
					viajes: [],
					viajestemp: [],
					isLoading: false,
					isPulse: false
				});
				console.log('No hay datos para la empresa seleccionada.');
			} else {
				this.setState({ isLoading: false, isPulse: false }, () => {
					this.cargarViajesEmpresariales();
				});
			}
		}).catch(error => {
			console.error('Error al cargar los datos:', error);
			this.setState({ isLoading: false, isPulse: false });
		});
	};

	cargarViajesEmpresariales = () => {
		let { clienteR, centroR, ViajesR, empleadosR, vehiculosR, empresaR, tarifas, programaciones, DetalleViaje } = this.state;

		let mostrar = [];
		for (let index = 0; index < ViajesR.length; index++) {
			let viajes = ViajesR[index];
			[viajes.emple].forEach(element => {
				let cantidadP = Object.keys(element).length;
				let encontrardoConduct = '';
				let costo = '';
				let area = [];
				let responsable = '';
				let encontrardoVehiculo = '';
				let encontradotarifas = '';
				let encontradoProgra = '';
				let clientesN = [];
				let fechaI = '---';
				let fechaA = [];
				let fechaB = [];
				let fechaF = '---';
				let desde = '';
				let hacia = [];
				let tarifaA = '---';
				let precioA = '---';
				let Solicito = '';
				let codClie = [];
				let fechaFti = '';
				let fechaIti = '';
				let suma = 0;
				let validos = [];
				let velocidadP = 0;
				desde = viajes.inicio;
				let fInicial = new Date(viajes.horaIni);
				let fFinal = new Date(viajes.horaFin);
				if (viajes.horaIni !== '') {
					fechaI = fInicial.getHours() + ':' + fInicial.getMinutes();
				}
				if (viajes.horaFin) {
					fechaF = fFinal.getHours() + ':' + fFinal.getMinutes();
				}
				if (viajes.destino !== undefined) {
					hacia.push(viajes.destino);
				}
				for (let index = 0; index < cantidadP; index++) {
					let objeCli = element[Object.keys(element)[index]];//importante
					let encontrardoClie = clienteR.find(client => {
						return objeCli.idEmple === client.key;
					})
					if (encontrardoClie !== undefined) {
						clientesN.push(`${encontrardoClie.nombre} ${encontrardoClie.apellido}`)
						codClie.push(encontrardoClie.numero_empleado)
						area.push(encontrardoClie.areaDesc)
						let fecha1 = new Date(objeCli.horaSubida)
						fechaA.push(fecha1.getHours() + ':' + fecha1.getMinutes())
						let fecha2 = new Date(objeCli.horaBajada)
						if (isNaN(fecha2.getHours()) === false) {
							fechaB.push(fecha2.getHours() + ':' + fecha2.getMinutes())
						}
						if (viajes.destino === undefined) {
							hacia.push(objeCli.destino);
						}
						let encontrardoCosto = centroR.find(client => {
							return encontrardoClie.centro === client.key;
						})
					}
				}
				encontrardoConduct = empleadosR.find(emple => {
					return viajes.conduc === emple.key;
				})
				if (encontrardoConduct) {
					encontrardoVehiculo = vehiculosR.find(vehi => {
						return viajes.vehiculo === vehi.key;
					})

				}
				if (viajes.tarifa !== undefined && viajes.tarifa !== '') {
					encontradotarifas = tarifas.find(tari => {
						return viajes.tarifa === tari.key;
					})
					if (encontrardoVehiculo)
						precioA = encontradotarifas.valores[(encontrardoVehiculo.tipo_vehiculo == 'Privado') ? 'Ejecutivo' : encontrardoVehiculo.tipo_vehiculo];

					tarifaA = encontradotarifas.tipo;
				}
				if (viajes.prograP !== undefined && viajes.prograP !== '') {
					encontradoProgra = programaciones.find(costo => {
						return viajes.prograP === costo.key;
					})
					if (encontradoProgra !== undefined) {
						if (encontradoProgra.centroC !== undefined) {
							let encontrardoCosto = centroR.find(centro => {
								return encontradoProgra.centroC === centro.key;
							})
							costo = encontrardoCosto.codigo;
							responsable = encontrardoCosto.responsable;
						}
						fechaIti = encontradoProgra.horaReco;
						fechaFti = encontradoProgra.horaAero;
					}
				}
				let encontrardoDetalle = DetalleViaje.find(detalle => {
					return viajes.key === detalle.key;
				})

				if (encontrardoDetalle !== undefined) {
					if (encontrardoDetalle.velocidad) {
						Array.prototype.forEach.call(encontrardoDetalle.velocidad, element => {
							if (element != '0' && element != '00.00' && element != '0.00') {
								validos.push(element)
								suma = Number(suma) + Number(element);
							}
						});
						velocidadP = suma / validos.length.toFixed(2);
					}
				}
				if (encontrardoConduct) {
					if (encontrardoConduct.nombre !== "") {
						if (encontradoProgra.tipo !== "pilotossap" && encontradoProgra.tipo !== "tcssap") {
							let fecha_registro = new Date(viajes.fecha).toLocaleDateString();
							let objeT = {
								key: viajes.key,
								cliente: empresaR ? this.setUndefined(empresaR.codigo_empresa) : "",
								empleado: encontrardoConduct ? this.setUndefined(encontrardoConduct.nombre) : "",
								fechaReserva: this.setUndefined(fechaI),
								fechaBajada: this.setUndefined(fechaF),
								fechaSubida: this.setUndefined(fechaI),
								horaSubida: this.setUndefined(fechaA.join(',')),
								horaBajada: this.setUndefined(fechaB.join(',')),
								movil: this.setUndefined(viajes.movil),
								pago: this.setUndefined(tarifaA),
								total: this.setUndefined(precioA),
								tipoV: encontrardoConduct ? this.setUndefined(encontrardoConduct.tipo_vehiculo) : "",
								foto: encontrardoConduct ? this.setUndefined(encontrardoConduct.foto) : "",
								keyEmpleado: encontrardoConduct ? this.setUndefined(encontrardoConduct.key) : "",
								detaCate: '#N/A',
								areaDesc: this.setUndefined(area.join(',')),
								cantTrayec: this.setUndefined(cantidadP),
								numero: this.setUndefined(cantidadP),
								numero_empleado: this.setUndefined(cantidadP),
								centro: this.setUndefined(costo),
								responsable: this.setUndefined(responsable),
								vehiculo: encontrardoVehiculo ? this.setUndefined(encontrardoVehiculo.placa.replace(/-/, '')) : "",
								personas: this.setUndefined(clientesN.join(',')),
								numero_empleado: this.setUndefined(codClie.join(',')),
								desde: this.setUndefined(viajes.nameIni),
								lugar: this.setUndefined(viajes.nameDes),
								combinacion: this.setUndefined(viajes.nameIni) + '/' + this.setUndefined(viajes.nameDes),
								kmInicial: this.setUndefined(viajes.kmInicial),
								kmFinal: this.setUndefined(viajes.kmFinal),
								fecha: this.setUndefined(viajes.fecha),
								fechaRegistro: this.setUndefined(fecha_registro),
								fechaIti: this.setUndefined(fechaIti),
								fechaFti: this.setUndefined(fechaFti),
								velocidadP: isNaN(velocidadP) ? "" : this.setUndefined(velocidadP.toFixed(2)),
								comentario: this.setUndefined(viajes.comentario)
							}
							mostrar.push(objeT);
						}
					}
				}
			});
		};
		this.setState({
			viajes: mostrar,
			viajestemp: mostrar
		});

		this.handleChangeDatePicker2();
		let index = 0;
	}

	setUndefined = (datos) => {
		if (datos === undefined) {
			return '---'
		}
		else {
			return datos
		}
	}

	onChangeEmpresas(e) {
		this.setState({ empreUID: e.target.value });
	}

	ocultarMenu() {
		store.dispatch({
			type: 'STATE_MOSTRAR',
			mostrar: 'noMostrar'
		})
	}

	handleChangeDatePicker1 = (e) => {
		let fecha1 = this.fecha1.value;
		this.fecha2.value = '';
		this.setState({
			fecha_hasta: '',
			fecha_minima: fecha1,
			input_disabled: ''
		});
	};

	handleChangeDatePicker2 = async () => {
		let fecha1 = this.fecha1.value;
		let fecha2 = this.fecha2.value;

		let f1 = new Date(fecha1);
		let f2 = new Date(fecha2);

		f1.setDate(f1.getDate() + 1);
		f2.setDate(f2.getDate() + 1);

		console.log(`Fecha desde: ${fecha1}, Fecha hasta: ${fecha2}`);

		// Verificar si las fechas han cambiado y si ambas fechas están definidas
		if (fecha1 && fecha2 && (fecha1 !== this.state.fecha_desde || fecha2 !== this.state.fecha_hasta)) {
			// Actualizar el estado con las nuevas fechas y mostrar la animación de carga
			this.setState({
				isLoading: true,
				fecha_desde: fecha1,
				fecha_hasta: fecha2
			}, async () => {
				// Llamar a getData después de actualizar el estado
				await this.getData();

				let newViajes = [];

				for (let i = 0; i < this.state.viajes.length; i++) {
					if (f2.toLocaleDateString() >= (new Date(this.state.viajes[i].fecha).toLocaleDateString()) && f1.toLocaleDateString() <= (new Date(this.state.viajes[i].fecha).toLocaleDateString())) {
						newViajes.push({
							key: this.state.viajes[i].key,
							cliente: this.state.viajes[i].cliente,
							empleado: this.state.viajes[i].empleado,
							fechaReserva: this.state.viajes[i].fechaReserva,
							fechaBajada: this.state.viajes[i].fechaBajada,
							fechaSubida: this.state.viajes[i].fechaSubida,
							horaSubida: this.state.viajes[i].horaSubida,
							horaBajada: this.state.viajes[i].horaBajada,
							movil: this.state.viajes[i].movil,
							pago: this.state.viajes[i].pago,
							total: this.state.viajes[i].total,
							tipoV: this.state.viajes[i].tipoV,
							foto: this.state.viajes[i].foto,
							keyEmpleado: this.state.viajes[i].keyEmpleado,
							detaCate: this.state.viajes[i].detaCate,
							areaDesc: this.state.viajes[i].areaDesc,
							cantTrayec: this.state.viajes[i].cantTrayec,
							numero: this.state.viajes[i].numero,
							numero_empleado: this.state.viajes[i].numero_empleado,
							centro: this.state.viajes[i].centro,
							responsable: this.state.viajes[i].responsable,
							vehiculo: this.state.viajes[i].vehiculo,
							personas: this.state.viajes[i].personas,
							numero_empleado: this.state.viajes[i].numero_empleado,
							desde: this.state.viajes[i].desde,
							lugar: this.state.viajes[i].lugar,
							combinacion: this.state.viajes[i].combinacion,
							kmInicial: this.state.viajes[i].kmInicial,
							kmFinal: this.state.viajes[i].kmFinal,
							fecha: moment(this.state.viajes[i].fecha).format('DD/MM/YYYY'),
							fechaFti: this.state.viajes[i].fechaFti,
							fechaIti: this.state.viajes[i].fechaIti,
							velocidadP: this.state.viajes[i].velocidadP,
							fechaRegistro: this.state.viajes[i].fechaRegistro,
							comentario: this.state.viajes[i].comentario
						});
					}
				}

				this.setState({
					viajes: newViajes,
					btndisabled: false,
					isLoading: false
				});
			});
		}
	}

	toggleDatePickers = () => {
		this.setState(prevState => ({
			showDatePickers: !prevState.showDatePickers
		}));
	}

	togglePersonas = (index) => {
		this.setState(prevState => ({
			visiblePersonas: {
				...prevState.visiblePersonas,
				[index]: !prevState.visiblePersonas[index]
			}
		}));
	}

	formatDate(dateString) {
		const date = new Date(dateString + 'T00:00:00');
		const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
		const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

		const dayName = days[date.getUTCDay()];
		const day = date.getUTCDate().toString().padStart(2, '0');
		const month = months[date.getUTCMonth()];
		const year = date.getUTCFullYear();

		return `${dayName} ${day} ${month} ${year}`;
	}

	formatTime = (time) => {
		if (!time || !time.includes(':')) {
			return '---';
		}
	
		const [hour, minute] = time.split(':');
		const hourInt = parseInt(hour, 10);
		const ampm = hourInt >= 12 ? 'p.m.' : 'a.m.';
		const formattedHour = hourInt % 12 || 12;
		const formattedMinute = minute.padStart(2, '0');
		return `${formattedHour}:${formattedMinute} ${ampm}`;
	}

	render() {
		const { viajes, empresaSelect, empresas, isLoading, isPulse, empreUID, visiblePersonas } = this.state;

		if (isLoading) {
			return <Pulse />
		}

		if (isPulse) {
			return <Pulse />
		}
		else {
			return (
				<div className="container" onClick={this.ocultarMenu}>
					<br />
					<div className="row">
						<div className="col-md-12 col-xs-12 col-sm-12 col-lg-12">
							<div className="selected-dates-container">
								<div className="selected-dates">
									<button className="calendar-button" onClick={this.toggleDatePickers}>
										<img src={Calendario} alt="Calendario" className="calendar-icon" />
									</button>
									{this.state.fecha_desde && this.state.fecha_hasta
										? (this.formatDate(this.state.fecha_desde) === this.formatDate(this.state.fecha_hasta)
											? this.formatDate(this.state.fecha_desde)
											: `${this.formatDate(this.state.fecha_desde)} - ${this.formatDate(this.state.fecha_hasta)}`)
										: "Seleccione las fechas"}
								</div>
							</div>
						</div>
						<div className={`col-md-6 col-xs-6 col-sm-6 col-lg-5 ${this.state.showDatePickers ? '' : 'hidden'}`}>
							<div className="col-md-12 margin10">
								<label>Fecha inicio</label>
								<input
									type="date"
									className="form-control"
									max={this.state.fecha_actual}
									onChange={this.handleChangeDatePicker1}
									ref={input => { this.fecha1 = input; }}
									defaultValue={this.state.fecha_desde}
								/>
							</div>
						</div>
						<div className={`col-md-6 col-xs-6 col-sm-6 col-lg-5 ${this.state.showDatePickers ? '' : 'hidden'}`}>
							<div className="col-md-12 margin10">
								<label>Fecha fin</label>
								<input
									type="date"
									className="form-control"
									max={this.state.fecha_actual}
									onChange={this.handleChangeDatePicker2}
									ref={input => { this.fecha2 = input; }}
									min={this.state.fecha_minima}
									defaultValue={this.state.fecha_hasta}
								/>
							</div>
						</div>
					</div>
					<br />

					<div className="container">
						{viajes && viajes.length > 0 ? (
							viajes.map((viaje, index) => (
								<React.Fragment key={index}>
									<div>Fecha: <span className="colorData">{viaje.fechaRegistro}</span></div>
									<div className="viaje-row">
										<div className="column">
											<div className="flex-container">
												<img src={Ubicacion} alt="Ubicacion" className="icon" />
												<div className="text-container">
													<div><span className="bold">Origen</span></div>
													<div className="colorData">{viaje.desde}</div>
												</div>
											</div>
											<div className="flex-container">
												<img src={Reloj} alt="Reloj" className="icon" />
												<div className="text-container">
													<div><span className="bold">Hora de inicio</span></div>
													<div className="colorData">{this.formatTime(viaje.fechaSubida)}</div>
												</div>
											</div>
											<div className="flex-container">
												<img src={Kilometraje} alt="Kilometraje" className="icon" />
												<div className="text-container">
													<div><span className="bold">Kilometraje inicial</span></div>
													<div className="colorData">{viaje.kmInicial}</div>
												</div>
											</div>
										</div>
										<div className="column">
											<div><span className="bold">Destino</span><br></br><span className="colorData">{viaje.lugar}</span></div>
											<div><span className="bold">Hora de fin</span><br></br><span className="colorData">{this.formatTime(viaje.fechaBajada)}</span></div>
											<div><span className="bold">Kilometraje final</span><br></br><span className="colorData">{viaje.kmFinal}</span></div>
										</div>
									</div>
									<div className="full-width">
										<div className="flex-container">
											<img src={Pasajeros} alt="Pasajeros" className="icon" />
											<div className="text-container">
												<div>
													<span className="bold">Cantidad de pasajeros</span>
													<button className="arrow-button" onClick={() => this.togglePersonas(index)}>
														<img src={Flecha} alt="Flecha" className={`arrow ${visiblePersonas[index] ? 'up' : 'down'}`} />
													</button>
												</div>
												<div className="colorData">{viaje.numero}</div>
											</div>
										</div>
										<div className={`flex-container ${visiblePersonas[index] ? '' : 'hidden'}`}>
											<div className="text-container2">
												<div className="column-left personas">
													{viaje.personas.split(',').map((persona, i) => (
														<div key={i} className="colorData">
															{persona.length > 20 ? `${persona.substring(0, 20)}...` : persona}
														</div>
													))}
												</div>
												<div className="column-right">
													{viaje.numero_empleado.split(',').map((numero, i) => (
														<div key={i} className="colorData">
															{numero.length > 20 ? `${numero.substring(0, 20)}...` : numero}
														</div>
													))}
												</div>
											</div>
										</div>
									</div>
									<hr className="hrBitEmp"></hr>
								</React.Fragment>
							))
						) : (
							<div>No hay datos disponibles</div>
						)}
					</div>
				</div>
			);
		}
	}
}
export default BitacoraEmpleados;


// WEBPACK FOOTER //
// ./src/Components/Empleados/BitacoraEmpleados.js